var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24x24/Folder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.499,1 L14,1 C14.315,1 14.611,1.148 14.8,1.4 L17.5,5 L20.499,5 C21.881,5 23,6.115 23,7.498 L23,20.502 C23,21.883 21.88,23 20.497,23 L3.503,23 C2.12,23 1,21.881 1,20.497 L1,3.503 C1,2.121 2.118,1 3.499,1 Z M10,3 L11.5,5 L15,5 L13.5,3 L10,3 Z M3.499,3 C3.224,3 3,3.225 3,3.503 L3,20.497 C3,20.776 3.224,21 3.503,21 L20.497,21 C20.776,21 21,20.777 21,20.502 L21,7.498 C21,7.221 20.778,7 20.499,7 L11,7 C10.685,7 10.389,6.852 10.2,6.6 L7.5,3 L3.499,3 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24x24/Folder",
    transform: "translate(-1.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#000000",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderBlack);
export default __webpack_public_path__ + "static/media/Folder_Black.20476b6a15d87b8f7a10f4ddf3509a63.svg";
export { ForwardRef as ReactComponent };